import { TFunction } from "i18next";
import * as Yup from "yup";

export function getTodayAt1530(): Date {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 15, 30, 0);
}

export function journalSupportFormSchema(t: TFunction) {
  return Yup.object({
    startTime: Yup.date().required(),
    endTime: Yup.date()
      .required()
      .test("max-time", t("calendar.journalSupport.validation.endAfterMaximum"), (end) => end <= getTodayAt1530())
      .test("end-after-start", t("calendar.journalSupport.validation.endBeforeStart"), function (end) {
        const { startTime } = this.parent as { startTime: Date | null };
        if (!startTime) {
          return true;
        }
        return end > startTime;
      }),
  });
}
